/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_SubInputs */

const en_mk_loop_sub = /** @type {(inputs: Mk_Loop_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your agent understands project context, proposes changes for review, and works through tasks with check evidence. You choose the approval points.`)
};

const id_mk_loop_sub = /** @type {(inputs: Mk_Loop_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent memahami konteks proyek, mengusulkan perubahan untuk ditinjau, dan mengerjakan tugas dengan bukti pemeriksaan. Kamu menentukan titik persetujuannya.`)
};

/**
* | output |
* | --- |
* | "Your agent understands project context, proposes changes for review, and works through tasks with check evidence. You choose the approval points." |
*
* @param {Mk_Loop_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_sub = /** @type {((inputs?: Mk_Loop_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_sub(inputs)
	return en_mk_loop_sub(inputs)
});